import millify from 'millify';
export var formatFileSize = function (size, space) {
  if (space === void 0) {
    space = true;
  }
  return millify(size || 0, {
    units: ['B', 'KB', 'MB', 'GB'],
    space: space
  });
};